function blockStickyContent() {
  const mainBlocks = document.querySelectorAll('.block-sticky-content');
  const header = document.querySelector('#page > header');

  if(mainBlocks) {
    mainBlocks.forEach(mainBlock => {
      const stickyNav = mainBlock.querySelector('.block-sticky-content__nav');
      const stickyPrev = mainBlock.querySelector('.block-sticky-content__nav-prev');
      const stickyNext = mainBlock.querySelector('.block-sticky-content__nav-next');
      const sections = mainBlock.querySelectorAll('.block-sticky-content__section');
      const sectionLinks = stickyNav.querySelectorAll('a');
      const observerOptions = {
        threshold: 0
      };

      const sectionObserverOptions = {
        rootMargin: '-50% 0% -50% 0%',
        threshold: 0
      };

      function resetSectionLinks() {
        sectionLinks.forEach(sectionLink => {
          sectionLink.classList.remove('active');
        });
      }

      //observer the parent block
      const mainObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!stickyNav) {return false};

          if(entry.isIntersecting) {
            stickyNav.classList.add('visible');
          }
          else {
            stickyNav.classList.remove('visible');
          }
        });
      }, observerOptions);

      mainObserver.observe(mainBlock);
      
      //observer the sections in the parent block
      const sectionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const sectionID = entry.target.id;
          const sectionLink = document.querySelector(`#sticky-nav-${sectionID}`);

          if (entry.isIntersecting && sectionLink) {
            resetSectionLinks();
            sectionLink.classList.add('active');
          }
          else {
            sectionLink.classList.remove('active');
          }
        });
      }, sectionObserverOptions);

      if (sections) {
        sections.forEach(section => {
          sectionObserver.observe(section);
        });
      }

      //click to section
      sectionLinks.forEach(sectionLink => {
        sectionLink.addEventListener('click', function(e) {
          const scrollPadding = 32;
          const headerHeight = header.offsetHeight;
          const targetOffset = headerHeight + scrollPadding;
          const targetID = sectionLink.getAttribute('data-target');
          const targetElement = document.getElementById(targetID);
          const targetPosition = targetElement.getBoundingClientRect();
          const elementTop = targetPosition.top + window.scrollY;
          const scrollHere = targetElement ? elementTop - targetOffset : 0;
          e.preventDefault();


          if (targetElement) {
            window.scrollTo ({
              behavior: 'smooth',
              top: scrollHere
            });
          }
        });
      });

      //mobile
      let totalItems = 0;
      let currentItem = 1;

      function updateCurrent(value) {
        sectionLinks.forEach(sectionLink => {
          sectionLink.parentElement.classList.remove('active');
        });

        stickyNav.style.setProperty('--current-item', value);
        mainBlock.querySelector(`li[data-item="${value}"]`).classList.add('active');
      }

      sectionLinks.forEach(sectionLink => {
        totalItems++;
      });

      stickyPrev.addEventListener('click', function() {
        currentItem--;
        //console.log(currentItem);

        if (currentItem === 1) {
          stickyPrev.classList.add('disabled');
        }
        else {
          stickyPrev.classList.remove('disabled');
        }

        updateCurrent(currentItem);
        if (currentItem !== totalItems) {
          stickyNext.classList.remove('disabled');
        }
      });

      stickyNext.addEventListener('click', function() {
        currentItem++;
        //console.log(currentItem);

        if (currentItem === totalItems) {
          stickyNext.classList.add('disabled');
        }
        else {
          stickyNext.classList.remove('disabled');
        }
      
        updateCurrent(currentItem);
        if (currentItem !== 1) {
          stickyPrev.classList.remove('disabled');
        }
      });
    });
  }
}

window.addEventListener('DOMContentLoaded', blockStickyContent);